import { SubmissionError } from 'redux-form';

import { parseErrors } from 'components/Forms/utils';

import Profile from './Profile';
import Email from './Email';
import Password from './Password';
import ForgotPassword from './ForgotPassword';
import RecoverPassword from './RecoverPassword';
import InviteUser from './InviteUser';
import AddUserModal from './AddUsersModal';
import User from './User';
import Organization from './Organization/Organization';
import RespondentsList from './RespondentsList';
import RespondentsToAccept from './RespondentsToAccept';
import WorkbenchInfo from './WorkbenchInfo/WorkbenchInfo';
import ProductInfo from './ProductInfo';
import DownloadSurveyUrls from './DownloadSurveyUrls/DownloadSurveyUrls';

import ProductGroup from './Wizard/ProductGroup';
import ProductSubGroup from './Wizard/ProductSubGroup';
import ProductTestingSegments from './Wizard/ProductTestingSegments';
import ProductResearchGoal from './Wizard/ProductResearchGoal';
import ProductAudienceGender from './Wizard/ProductAudienceGender';
import ProductAudienceAge from './Wizard/ProductAudienceAge';
import ProductAudienceCountry from './Wizard/ProductAudienceCountry';
import Summary from './Wizard/Summary';
import AssetDetails from './AssetsDetails';
import AssetAddNew from './AssetAddNew';
import AutomaticDataCollect from './AutomaticDataCollect';
import UploadPanelistEmails from './UploadPanelistEmails';
import UploadPanelistCSV from './UploadPanelistCSV';
import TemplateCreator from './TemplateCreator/TemplateCreator';
import TokenRaise from './TokenRaise';
import InviteUserToOrganization from './Organization/InviteUser';
import EditUserInOrganization from './Organization/EditUser';
import AddGroupToOrganization from './Organization/AddGroup';
import EditGroupInOrganization from './Organization/EditGroup';

export default {
  Profile,
  Email,
  Password,
  EditGroupInOrganization,
  ForgotPassword,
  RecoverPassword,
  InviteUser,
  AddUserModal,
  AddGroupToOrganization,
  User,
  Organization,
  RespondentsList,
  RespondentsToAccept,
  WorkbenchInfo,
  ProductInfo,
  InviteUserToOrganization,
  EditUserInOrganization,
  DownloadSurveyUrls,
  AssetDetails,
  AssetAddNew,
  AutomaticDataCollect,
  UploadPanelistEmails,
  UploadPanelistCSV,
  TemplateCreator,
  TokenRaise,
  Wizard: {
    ProductGroup,
    ProductSubGroup,
    ProductTestingSegments,
    ProductResearchGoal,
    ProductAudienceGender,
    ProductAudienceAge,
    ProductAudienceCountry,
    Summary,
  },
  helpers: {
    throwError: (errors: any) => {
      throw new SubmissionError(parseErrors(errors));
    },
  },
};
